export default "__VITE_ASSET__24a1ca83__"